import React, { Suspense } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row, Col, Spinner } from 'react-bootstrap';
import { Route, Routes as Switch } from "react-router-dom";

import Header from '../../layout/header';
import BreadcrumbList from "../../layout/breadcrumbs";
import pages from "../../constants/menu";
import breadcrumbs, { find } from "../../layout/breadcrumbs/calculate";
import Layout from "../../layout";

import Profile from "../profile";
import Display from "./display";
import Users from "../users";
import User from "../users/detail";
import Courts from "../courts";
import Court from "../courts/detail";
import Matters from "../matters";
import Matter from "../matters/detail";
import Settings from "../settings";
import AccountingSettings from "../settings/accounting";
import EventSettings from "../settings/events";
import LeadSettings from "../settings/leads";
import LeadWorkflowEditor from "../leads/workflows";
import BoardSettings from "../settings/boards";
import EmailSettings from "../settings/email";
import EmailSettingItem from "../settings/email/item";
import HookSettings from "../settings/hooks";
import CalendarSettings from "../settings/calendars";
import CalendarSettingItem from "../settings/calendars/item";
import RoleSettings from "../roles";
import RoleSettingItem from "../roles/detail";
import TemplateSettings from "../settings/template";
import TemplateSettingEmail from "../settings/template/email";
import TemplateSettingReport from "../settings/template/report";
import RateSettings from "../settings/rates";
import RateSettingItem from "../settings/rates/item";
import ExpenseSettings from "../settings/expenses";
import ExpenseSettingItem from "../settings/expenses/item";
import AccountingDashboard from "../accounting/dashboard";
import Accounts from "../accounting/accounts";
import AccountItem from "../accounting/accounts/item";
import FinancialAccounts from "../accounting/financial.accounts";
import FinancialAccountItem from "../accounting/financial.accounts/item";
import Ledger from "../accounting/ledger";
import CheckRegister from "../accounting/check.register";
import BankReconciliations from "../accounting/reconciliations";
import BankReconciliationItem from "../accounting/reconciliations/item";
import PayPeriodSettings from "../accounting/pay.periods";
import PayPeriodSettingItem from "../accounting/pay.periods/item";
import PayScheduleSettings from "../accounting/pay.schedules";
import PayScheduleSettingItem from "../accounting/pay.schedules/item";
import PayRoll from "../accounting/payroll";
import PayRollItem from "../accounting/payroll/item";
import People from "../people";
import Person from "../people/detail";
import Companies from "../companies";
import Leads from "../leads";
import NotificationsPage from "../notifications";
import SurveySettings from "../settings/surveys";
import SurveySettingItem from "../settings/surveys/item";
import FirmItem from "../firm";
import SignatureEnvelopeCreate from "../signatures/create";
import SignatureEnvelopeDetail from "../signatures/detail";

const SurveyBuilder = React.lazy(() => import("../settings/surveys/editor"));

class Dashboard extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            page: find(window.location.pathname, pages),
        }
    }

    componentDidUpdate(oldProps) {

    }

    get title() {
        const liveTitle = String(this.props.page?.title || "").trim();
        if (liveTitle.length) return liveTitle;

        const fallbackTitle = String(this.state.page?.title || "").trim();
        if (fallbackTitle.length) return fallbackTitle;

        return "Dashboard";
    }

    render() {
        const breadcrumbItems = breadcrumbs(window.location.pathname, pages);
        const contextualBreadcrumbs = this.props.page?.breadcrumbPath === window.location.pathname
            ? this.props.page?.breadcrumbItems || []
            : [];
        breadcrumbItems.splice(1, 0, ...contextualBreadcrumbs);

        return (
            <>
                <Layout>
                    <Header title={`${localStorage.title ?? ""} | ${this.title ?? ""}`} description={`${this.props.profile?.dashboardTitleBase || ""} | ${this.state.page?.description || ""}`} />
        
                    {/* Title and Top Buttons Start */}
                    <div className="page-title-container">
                        <Row>
                            {/* Title Start */}
                            <Col md="4">
                                <h1 className="mb-0 pb-0 display-4">{this.title ?? ""}</h1>
                                <BreadcrumbList items={breadcrumbItems} title={this.props.page?.breadcrumb} />
                            </Col>
                            <Switch>
                                <Route exact={true} path="/profile" element={<Profile />} />
                                <Route exact={true} path="/accounting" element={<AccountingDashboard />} />
                                <Route exact={true} path="/accounting/accounts" element={<Accounts />} />
                                <Route exact={true} path="/accounting/accounts/:uuid" element={<AccountItem />} />
                                <Route exact={true} path="/accounting/ledger" element={<Ledger />} />
                                <Route exact={true} path="/accounting/checks/register" element={<CheckRegister />} />
                                <Route exact={true} path="/accounting/reconciliations" element={<BankReconciliations />} />
                                <Route exact={true} path="/accounting/reconciliations/:uuid" element={<BankReconciliationItem />} />
                                <Route exact={true} path="/accounting/financial-accounts" element={<FinancialAccounts />} />
                                <Route exact={true} path="/accounting/financial-accounts/:uuid" element={<FinancialAccountItem />} />
                                <Route exact={true} path="/accounting/payperiods" element={<PayPeriodSettings />} />
                                <Route exact={true} path="/accounting/payperiods/:uuid" element={<PayPeriodSettingItem />} />
                                <Route exact={true} path="/accounting/payschedules" element={<PayScheduleSettings />} />
                                <Route exact={true} path="/accounting/payschedules/:uuid" element={<PayScheduleSettingItem />} />
                                <Route exact={true} path="/accounting/payroll" element={<PayRoll />} />
                                <Route exact={true} path="/accounting/payroll/:uuid" element={<PayRollItem />} />
                                <Route exact={true} path="/settings" element={<Settings />} />
                                <Route exact={true} path="/settings/accounting" element={<AccountingSettings />} />
                                <Route exact={true} path="/settings/events" element={<EventSettings />} />
                                <Route exact={true} path="/settings/leads" element={<LeadSettings />} />
                                <Route exact={true} path="/settings/lead-workflow" element={<LeadWorkflowEditor />} />
                                <Route exact={true} path="/settings/boards" element={<BoardSettings />} />
                                <Route exact={true} path="/settings/calendars" element={<CalendarSettings />} />
                                <Route exact={true} path="/settings/calendars/:uuid" element={<CalendarSettingItem />} />
                                <Route exact={true} path="/settings/email" element={<EmailSettings />} />
                                <Route exact={true} path="/settings/email/:uuid" element={<EmailSettingItem />} />
                                <Route exact={true} path="/settings/hooks" element={<HookSettings />} />
                                <Route exact={true} path="/settings/firm" element={<FirmItem />} />
                                <Route exact={true} path="/settings/rates" element={<RateSettings />} />
                                <Route exact={true} path="/settings/rates/:uuid" element={<RateSettingItem />} />
                                <Route exact={true} path="/settings/expenses" element={<ExpenseSettings />} />
                                <Route exact={true} path="/settings/expenses/:uuid" element={<ExpenseSettingItem />} />
                                <Route exact={true} path="/settings/surveys" element={<SurveySettings />} />
                                <Route exact={true} path="/settings/surveys/editor" element={<Suspense fallback={<Col xs="12" className="py-5 text-center"><Spinner animation="border" /></Col>}><SurveyBuilder /></Suspense>} />
                                <Route exact={true} path="/settings/surveys/editor/:uuid" element={<Suspense fallback={<Col xs="12" className="py-5 text-center"><Spinner animation="border" /></Col>}><SurveyBuilder /></Suspense>} />
                                <Route exact={true} path="/settings/surveys/:uuid" element={<SurveySettingItem />} />
                                <Route exact={true} path="/settings/roles" element={<RoleSettings />} />
                                <Route exact={true} path="/settings/roles/:uuid" element={<RoleSettingItem />} />
                                <Route exact={true} path="/templates" element={<TemplateSettings />} />
                                <Route exact={true} path="/templates/email/:uuid" element={<TemplateSettingEmail />} />
                                <Route exact={true} path="/templates/report/:uuid" element={<TemplateSettingReport />} />
                                <Route exact={true} path="/users/:uuid" element={<User />} />
                                <Route exact={true} path="/users" element={<Users />} />
                                <Route exact={true} path="/courts/:uuid" element={<Court />} />
                                <Route exact={true} path="/courts" element={<Courts />} />
                                <Route exact={true} path="/matters/:uuid" element={<Matter />} />
                                <Route exact={true} path="/matters" element={<Matters />} />
                                <Route exact={true} path="/companies/:uuid" element={<Person company />} />
                                <Route exact={true} path="/companies" element={<Companies />} />
                                <Route exact={true} path="/leads" element={<Leads />} />
                                <Route exact={true} path="/signatures/new" element={<SignatureEnvelopeCreate />} />
                                <Route exact={true} path="/signatures/:uuid" element={<SignatureEnvelopeDetail />} />
                                <Route exact={true} path="/notifications" element={<NotificationsPage />} />
                                <Route exact={true} path="/people/:uuid" element={<Person />} />
                                <Route exact={true} path="/people" element={<People />} />
                                
                                <Route exact={true} path="/" element={<Display />} />
                            </Switch>
                        </Row>
                        <Row>

                        </Row>
                    </div>
                    {/* Title and Top Buttons End */}
                    
                </Layout>
            </>
        );
    }
}

Dashboard.propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth,
        profile: state.licensee.profile,
        page: state.page,
    });
};

export default connect(mapStateToProps)(Dashboard);
